// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const BasicWarrantyEstimator = t.struct({
    account: t.maybe(t.String),
    accumulatedDaysOnRent: t.maybe(t.Number),
    currentAmountOfUse: t.maybe(t.Number),
    currentlyOnRent: t.maybe(t.String),
    description: t.maybe(t.String),
    estimatedBasicDate: t.maybe(t.Number),
    estimatedBasicDays: t.maybe(t.Number),
    exceedsDemoThreshold: t.maybe(t.String),
    invoiceDate: t.maybe(t.Number),
    location: t.maybe(t.String),
    model: t.maybe(t.String),
    name: t.maybe(t.String),
    pin: t.maybe(t.String),
    reportDate: t.maybe(t.Number),
    unit: t.maybe(t.String)
}, {
    name: 'BasicWarrantyEstimator',
    strict: true
});

export const getDefaultState = () => new BasicWarrantyEstimator({
});

export default BasicWarrantyEstimator;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/basic-warranty-estimator.js